module.exports = __webpack_public_path__ + "fc3a0b41a68121c887a44ad586a5af79.svg";